<template>
  <div>
    <v-container class="pt-0 pb-5">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <SportipsButton toPage="FicheCoureur" chevronLeft mobile-full-width>Retour à ma fiche coureur
            </SportipsButton>

            <div class="text-h6 font-weight-bold my-3"><v-icon icon="mdi-file-document-edit-outline" color="primary"
                size="xs-small"></v-icon> Changement de parcours</div>


            <InscriptionItem v-if="bookingStore.has_initial_commande_inscription_loaded"
              :item="bookingStore.inscriptions[0]"
              :initial_commande_inscription="bookingStore.initial_commande_inscription">
            </InscriptionItem>

            <v-divider></v-divider>
            <v-row v-if="bookingStore.show_reglement_checkboxes">
              <v-col>
                <v-checkbox v-if="bookingStore.has_remaining_credit" class="checkbox_connaissance mb-1"
                  color="primary-dark" hide-details v-model="accept_credit">
                  <template v-slot:label>
                    <p>J'accepte que tout crédit non utilisé lors de ce changement de parcours sera perdu et non
                      remboursé.</p>
                  </template>
                </v-checkbox>
                <v-checkbox class="checkbox_connaissance mb-1" color="primary-dark" hide-details
                  v-model="accept_reglement">
                  <template v-slot:label v-if="!mainStore.billetterie_mode">
                    <p>J'ai pris connaissance du <a v-if="mainStore.module.url_reglement" target="_blank"
                        :href="mainStore.module.url_reglement">règlement</a><span v-else>règlement</span>, en accepte
                      les termes sans réserve.</p>
                  </template>
                  <template v-slot:label v-else>
                    <p>J'ai pris connaissance des <a v-if="mainStore.module.url_reglement" target="_blank"
                        :href="mainStore.module.url_reglement">CGV</a><span v-else>CGV</span>, en accepte les termes
                      sans réserve.</p>
                  </template>
                </v-checkbox>
                <v-checkbox class="checkbox_connaissance mb-1" color="primary-dark" hide-details
                  v-model="accept_donnees">
                  <template v-slot:label>
                    <p>J'ai pris connaissance des <a href="https://sportips.fr/vie-privee.php"
                        target="_blank">informations relatives au traitement de mes données</a>, dont j'autorise le
                      recueil par Sportips.</p>
                  </template>
                </v-checkbox>
                <v-checkbox class="checkbox_connaissance mb-1" color="primary-dark" hide-details
                  v-model="accept_newsletter">
                  <template v-slot:label>
                    <p>J'accepte de recevoir les news Courses de la part de Sportips.</p>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
            <div class="d-flex justify-center mb-1 mx-1" v-if="bookingStore.show_reglement_checkboxes">
              <SportipsButton v-if="bookingStore.has_some_inscriptions_opened" toPage="ChangerParcoursCart"
                icon="mdi-credit-card" action-button mobile-full-width chevron disabled>
                Finaliser mon changement
                <v-tooltip activator="parent" location="top">Vous devez compléter l'inscription ouverte afin de
                  finaliser votre inscription</v-tooltip>
              </SportipsButton>

              <SportipsButton
                v-else-if="!accept_donnees || !accept_reglement || (bookingStore.has_remaining_credit && !accept_credit)"
                toPage="ChangerParcoursCart" icon="mdi-credit-card" action-button mobile-full-width chevron disabled>
                Finaliser mon changement
                <v-tooltip activator="parent" location="top">Vous devez accepter le règlement de l'épreuve et autoriser
                  Sportips à traiter vos données</v-tooltip>
              </SportipsButton>

              <SportipsButton v-else toPage="ChangerParcoursCart" icon="mdi-credit-card" action-button mobile-full-width
                chevron>
                Finaliser mon changement
              </SportipsButton>
            </div>
          </div>
        </v-col>
        <v-col lg="3" cols="12">
          <ShoppingCart v-if="bookingStore" ref="shopping_cart">
          </ShoppingCart>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";

import InscriptionItem from "@/components/FicheCoureur/ChangementParcours/InscriptionItem.vue";
import ShoppingCart from "@/components/App/Shopping_Cart/Shopping_Cart.vue";
export default {
  components: {
    InscriptionItem,
    ShoppingCart,
  },
  data() {
    return {
      accept_reglement: false,
      accept_donnees: false,
      accept_newsletter: true,
      accept_credit: false,
    };
  },
  computed: {
    ...mapStores(useMainStore, useBookingStore),
  },
  methods: {
  },
  async created() {
    if (!this.mainStore.authUser.isLogged) {
      this.$router.push({ name: "FicheCoureur" });
    }
    if (!this.$route.params.id_commande_inscription) {
      this.$router.push({ name: "FicheCoureur" });
    }
    this.mainStore.bookingSystem.init();
    await this.mainStore.champs_formulaire.fetch();
    await this.bookingStore.init_initial_commande_inscription(this.$route.params.id_commande_inscription);
  },
};
</script>

<style lang="scss" scoped></style>